import { Form, Formik } from "formik";
import Title from "../../components/common/title/Title";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Select from "../../components/common/inputs/Select";
import Button from "../../components/common/button/Button";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useRef, useState } from "react";
import Editor from "../../components/common/ck-editor/CkEditor";
import { termsValidation } from "../../utils/validations/termsValidation";

export default function TermsForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const [content, setContent] = useState("");

  const formHandler = async (values, { resetForm }) => {
    if (content.length) {
      const body = {
        ...values,
        content,
      };
      try {
        if (location.state) {
          await putApi({
            path: `admin/terms/${location.state?.id}`,
            body: JSON.stringify(body),
          });
          successMessage("قانون با موفقیت ویرایش شد");
        } else {
          await postApi({
            path: "admin/terms",
            body: JSON.stringify(body),
          });
          successMessage("قانون با موفقیت اضافه شد");
        }
        resetForm();
        navigate("/terms-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("لطفا محتوای قانون را پر کنید");
    }
  };

  const copyImagesUrlModal = useRef();

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={location?.state ? "ویرایش قانون" : "افزودن قانون"} />
        <Formik
          enableReinitialize
          initialValues={{
            title: location?.state?.title || "",
            part: location?.state?.part || "",
          }}
          validationSchema={termsValidation}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <Input
                    name="title"
                    placeholder="عنوان"
                    label="عنوان"
                    type="text"
                  />

                  <Select name="part" placeholder="دسته‌بندی" label="دسته‌بندی">
                    <option value={""} selected>
                      انتخاب دسته‌بندی
                    </option>
                    {utils
                      ? utils.TERMS_PART_VALUES.map((item) => {
                          return (
                            <option key={item.value} value={item.value}>
                              {item?.name}
                            </option>
                          );
                        })
                      : null}
                  </Select>
                </div>
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس"}
                  color={"primary"}
                  className="mb-3"
                />

                <Editor
                  onChange={setContent}
                  filed={"content"}
                  defultData={location?.state?.content || null}
                />

                <div className="flex flex-col gap-y-2">
                  <div className="mt-6">
                    <Button
                      text={location?.state ? "ویرایش" : "افزودن"}
                      type={"success"}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
    </>
  );
}
